import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    typography: {
        h3: {
            fontSize: "2.1rem",      
            fontWeight: 500,
            lineHeight: 1.25,
            marginBottom: "0.75rem",
            "@media (max-width:600px)": {
                fontSize: "1.55rem", 
                lineHeight: 1.3
            }
        },
        h6: {
            fontSize: "1.1rem",
            fontWeight: 500,
            lineHeight: 1.3,
            "@media (max-width:600px)": {
                fontSize: "1rem",
                lineHeight: 1.25,
            },
        },
        subtitle1: {
            fontSize: "1rem",
            "@media (max-width:600px)": {
                fontSize: "0.95rem",
            },
        },
        body1: {
            fontSize: "1rem",
            "@media (max-width:600px)": {
                fontSize: "0.95rem",
            },
        },
        body2: {
            fontSize: "0.875rem",
            "@media (max-width:600px)": {
                fontSize: "0.82rem",
            },
        },
    },
});